
import { Vue } from 'vue-property-decorator';

export const MUTATE_ISSUER = 'MUTATE_ISSUER';

export interface IssuerPayload {
    address: string;
    email: string;
}

interface IssuerStore {
    issuers: any;
}

// initial state
const issuerState: IssuerStore = {
    issuers: {
        address: 'email',
    },
};

// getters
const getters = {
    getEmailOfIssuer: (state: IssuerStore) => (address: string) => {
        const email = state.issuers[address];
        if (email) {
            return email;
        }
        return '';
    },
};

// mutations
const mutations = {
    [MUTATE_ISSUER](state: IssuerStore, payload: IssuerPayload) {
        Vue.set(state.issuers, payload.address, payload.email);
    },
};

// actions
const actions = {
    // [MUTATE_PRODUCTS](context: any, payload: any) {
    //     context.commit(MUTATE_PRODUCTS, payload);
    // },
};


export default {
    state: issuerState,
    getters,
    actions,
    mutations,
};
